<template>
    <span v-if="showHelp">
        <v-tooltip right>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    color="accent"
                    small
                    class="mx-2"
                    :href="href"
                    target="_guide"
                    v-on="on"
                >
                    <v-icon>{{ icons.help }}</v-icon>
                </v-btn>
            </template>
            <span>{{ tooltipText }}</span>
        </v-tooltip>
    </span>
</template>

<script>
export default {
    name: 'HelpButton',
    props: {
        href: {
            type: String,
            required: true
        },
        tooltipText: {
            type: String,
            default: 'Open the user guide'
        }
    },
    computed: {
        showHelp() {
            return this.href;
        }
    }
};
</script>

<style></style>
